import { render, staticRenderFns } from "./KoioteSelectorProperties.vue?vue&type=template&id=b2259604&"
import script from "./KoioteSelectorProperties.vue?vue&type=script&lang=js&"
export * from "./KoioteSelectorProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports